module.exports = __webpack_public_path__ + "static/img/5.7dfa0b9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/3/eng/5.png
// module id = JgM3
// module chunks = 0